module.exports = __webpack_public_path__ + "static/navbar2-7d148e89de974eea410b2361db8b468f.png";